import { render, staticRenderFns } from "./addlayout.vue?vue&type=template&id=5f105b35&scoped=true"
import script from "./addlayout.vue?vue&type=script&lang=js"
export * from "./addlayout.vue?vue&type=script&lang=js"
import style0 from "./addlayout.vue?vue&type=style&index=0&id=5f105b35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f105b35",
  null
  
)

export default component.exports